import React, { useState, useEffect } from "react";

const Slider = () => {
  const images = [
    // "./images/pic-3.jpeg",
    "./images/slider-1.jpg",
    "./images/slider-1.jpg",
    "./images/slider-1.jpg",
    // "./images/slider-4.jpg",
    // "./images/pic-2.jpeg",
    // "./images/pic-4.jpeg"
    // "./images/pic-6.jpeg"
  ];

  const mobimages = [
   
    // "./images/slider-mob-1.jpg",
    // "./images/slider-mob-1.jpg",
     "./images/slider-1.jpg",
    "./images/slider-1.jpg",
    "./images/slider-1.jpg",
    "./images/slider-1.jpg",
  ];

  const [current, setCurrent] = useState(0);

  // Auto-play (slow down here)
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 6000);  // ⬅ Change this value (6000 = 6 seconds)

    return () => clearInterval(interval);
  }, [images.length]);

  const nextSlide = () => {
    setCurrent((current + 1) % images.length);
  };

  const prevSlide = () => {
    setCurrent((current - 1 + images.length) % images.length);
  };

  return (
    <div className="slider" style={{ width: "100%",marginTop:'-50px',position:'relative'}}>
      

     <img
  key={current}
  src={images[current]}
  alt="Slider"
  className="slide-image slide"
  style={{ width: "100%" }}
/>

<img
  key={"mob-" + current}
  src={mobimages[current]}
  alt="Slider"
  className="mob-slide-image slide"
  style={{ width: "100%" }}
/>

      <div style={{display:'flex',justifyContent:'end',marginTop:'-100px',marginBottom:'150px',padding:'0px 45px'}}>
        <button  className="btn arrows" onClick={prevSlide}>❮</button>
      <button  className="btn arrows" onClick={nextSlide}>❯</button>
      </div>
      
    </div>

    
  );
};

export default Slider;
